// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"56":"5601819124819e05c898","579":"f6562acb031fb5ebacf0"}[chunkId] + ".js";
};